goog.provide("shadow.js.shim.module$src$svg$chevron$chevron_up_svg$default");
shadow.js.shim.module$src$svg$chevron$chevron_up_svg$default = shadow.js.shim.module$src$svg$chevron$chevron_up_svg.default;
